module.exports = __webpack_public_path__ + "static/media/ic-time.ec8f49fb.svg";